import { render, staticRenderFns } from "./TrashedMembers.vue?vue&type=template&id=59ea8aac"
import script from "./TrashedMembers.vue?vue&type=script&lang=js"
export * from "./TrashedMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports